import React, {useState, useRef, useEffect, useContext} from 'react'
import {SlideDown} from 'react-slidedown'
import Icon from "icons/icon"
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Burger.scss'
import 'react-slidedown/lib/slidedown.css'
import AuthContext from 'app/AuthContext'
import profileImage from 'images/blank-profile-picture.png'
import { getProjCategoryOpts } from 'lib/project';
import { formatAvatarUrl } from 'lib/utils';
import { getDefaultUserCommunities } from 'lib/user';
import {FormModal, ContactForm} from 'sub-components'
import Home02 from "@untitled-ui/icons-react/build/cjs/Home02";
import Globe05 from "@untitled-ui/icons-react/build/cjs/Globe05";
import CameraPlus from "@untitled-ui/icons-react/build/cjs/CameraPlus";
import LogOut04 from "@untitled-ui/icons-react/build/cjs/LogOut04";
import Mail01 from "@untitled-ui/icons-react/build/cjs/Mail01";
import InfoCircle from "@untitled-ui/icons-react/build/cjs/InfoCircle";
import LogIn04 from "@untitled-ui/icons-react/build/cjs/LogIn04";
import ArrowCircleBrokenUpRight from "@untitled-ui/icons-react/build/cjs/ArrowCircleBrokenUpRight";
import Share06 from "@untitled-ui/icons-react/build/cjs/Share06";

const Burger = ({ handleSignUpClick, handleSignInClick, handleLogOutClick, handleProfileClick, handleCreateClick, setAreYouSureModal }) => {
	const [isMenuDisplayed, setIsMenuDisplayed] = useState(false);
	const [isCategoriesClosed, setIsCategoriesClosed] = useState(true);
	const [isCommunitiesClosed, setIsCommunitiesClosed] = useState(true);
	const [menuClass, setMenuClass] = useState(
		'js-colorlib-nav-toggle colorlib-nav-toggle colorlib-nav-white'
	);
	const navigate = useNavigate();
	const category = getProjCategoryOpts();
	const defaultCommunities = getDefaultUserCommunities();
	const location = useLocation();

	const [notificationVisible, setNotificationVisible] = useState(false); // State for notification

	const { authToken, userMetadata} = useContext(AuthContext);
	const wrapperRef = useRef();

	// Contact form items
	const [isContactFormToggleOn, setIsContactFormToggleOn] = useState(false);
    const [actionCompleted, setActionCompleted] = useState(false);

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handleClickOutside = (event) => {
		if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
			if (isMenuDisplayed) {
				toggleBurger();
			}
		}
	};

	const toggleBurger = () => {
		if (isMenuDisplayed) {
			setMenuClass('js-colorlib-nav-toggle colorlib-nav-toggle colorlib-nav-white');
			setIsMenuDisplayed(false);
			setIsCategoriesClosed(true);
			document.body.classList.remove('fixed-body');
		} else {
			setMenuClass('active js-colorlib-nav-toggle colorlib-nav-toggle colorlib-nav-white');
			setIsMenuDisplayed(true);
			document.body.classList.add('fixed-body');
		}
	};

	const isOnboardingCompleted = () => {
		const isOnboarding = location.pathname.includes('onboarding');
		if ( isOnboarding && userMetadata && (userMetadata.last_successful_login_ts === null || userMetadata.last_successful_login_ts < 1744948800000) ) {
			return false;
		}
		return true;
	}

	const toggleCategories = () => {
		setIsCategoriesClosed(!isCategoriesClosed);
	};

	const toggleCommunities = () => {
		setIsCommunitiesClosed(!isCommunitiesClosed);
	};

	const handleSignUp = () => {
		toggleBurger();
		handleSignUpClick();
	};

	const handleSignIn = () => {
		toggleBurger();
		handleSignInClick();
	};

	const handleLogOut = () => {
		toggleBurger();
		handleLogOutClick();
	}

	const handleProfile = () => {
		toggleBurger();
		handleProfileClick();
	}

	const handleCreate = () => {
		toggleBurger();
		handleCreateClick();
	}

	const handleCommunityClick = (comm) => {
		toggleBurger();
		if(isOnboardingCompleted()) {
			navigate(`${comm}`);
		} else {
			setAreYouSureModal(true);
		}
	}

	const handleLinkClick = (endpoint) => {
		toggleBurger();
		if(isOnboardingCompleted()) {
			navigate(`/${endpoint}`);
		} else {
			setAreYouSureModal(true);
		}
	}

	const handleActionCompleted = () => {
        setActionCompleted(true);
        setTimeout(() => {
            setIsContactFormToggleOn(false);
        }, 1000);
    }

    const handleContactClick = () => {
        setIsContactFormToggleOn(!isContactFormToggleOn);
        setActionCompleted(false);
    }

	// Share video function copies the profile link to the clipboard
    const shareVideo = () => {
		if (isOnboardingCompleted()) {
			const currentProfileEndpoint = process.env.REACT_APP_ENVIRONMENT === "dev" ? "http://localhost:3000/profile/" : "https://www.sidejawn.io/profile/";
			const profileLink = currentProfileEndpoint + userMetadata?.id;

			// Check if navigator.clipboard is available
			if (navigator.clipboard) {
				navigator.clipboard.writeText(profileLink).then(() => {
					setNotificationVisible(true); // Show notification
					setTimeout(() => {
						setNotificationVisible(false); // Hide notification after 2 seconds
					}, 2000);
				}).catch(err => {
					console.error('Failed to copy: ', err);
				});
			} else {
				// Fallback method
				const textarea = document.createElement('textarea');
				textarea.value = profileLink;
				document.body.appendChild(textarea);
				textarea.select();
				try {
					document.execCommand('copy'); // Attempt to copy
					setNotificationVisible(true); // Show notification
					setTimeout(() => {
						setNotificationVisible(false); // Hide notification after 2 seconds
					}, 2000);
				} catch (err) {
					console.error('Fallback: Unable to copy: ', err);
				}
				document.body.removeChild(textarea); // Clean up
			}
		} else {
			setAreYouSureModal(true);
		}
    };

	return (
		<div ref={wrapperRef} className={isMenuDisplayed ? "overflow offcanvas" : ""}>
			<FormModal 
                isToggleOn={isContactFormToggleOn} 
                handleClick={handleContactClick}
                actionCompleted={actionCompleted}
                title="Contact Us"
                successfulActionTitle="Message Sent"
                successfulActionMessage="Thanks for contacting us. We will respond via email.">
                <ContactForm onActionCompleted={handleActionCompleted} />
            </FormModal>
			<a onClick= {toggleBurger} className={menuClass}><i></i></a>
			<div id="colorlib-offcanvas" className={isMenuDisplayed ? "" : "closed"}>
				<ul>
					{ authToken && 
						<>
							{/* <li><Link onClick= {() => handleLinkClick('discovery')}><Home02/> Explore</Link></li> */}
							<li className="disabled-menu-item" >
								<a className="disabled"><Globe05/> Communities</a>
								<SlideDown className={'pure-menu pure-menu-scrollable dropdown-slidedown'} closed={true}>
									<ul>
										{defaultCommunities.map((community, index) => (
											<li key={index} className="disabled-menu-item">
												<a
													style={{ fontSize: '14px'}}
													className="disabled"
												>
													{community.label}
												</a>
											</li>
										))}
									</ul>
								</SlideDown>
							</li>
							<hr className="menu-division"/>
						</>
					}
					{/* <li><Link onClick= {toggleBurger} to="/resources">Resources</Link></li> */}
					{/* <li className="" > */}
					{/* <a style={{cursor:'pointer'}} onClick= {toggleCategories}>Startups <Icon color="white" className="dropdown-icon" size={10} icon="circle-down"/></a>
						<SlideDown className={'pure-menu pure-menu-scrollable dropdown-slidedown'} closed={isCategoriesClosed}>
							<ul>
								<li><a style={{cursor:'pointer'}} onClick={() => handleCategoryClick('all')}>All</a></li>
								{category.map(item => (
									<li key={item.value}>
										<a style={{cursor:'pointer'}} onClick={() => handleCategoryClick(item.value)}>{item.label}</a>
									</li>
								))}
							</ul>
						</SlideDown>
					</li> */}
					{authToken ? (
						<>
							<li className="disabled-menu-item"><a className="disabled"><CameraPlus/> Post pitch</a></li>
							<li className="disabled-menu-item"><a className="disabled"><Share06/> Share Your Profile</a></li>
							<hr className="menu-division"/>
							<li className="profile-container-mobile disabled-menu-item">
								<div className="profile-circle-mobile disabled" style={{backgroundImage: `url(${userMetadata?.user_avatar ? formatAvatarUrl(userMetadata.user_avatar.url, userMetadata.user_avatar.updated_ts) : profileImage})`}}>
								</div>
								{userMetadata && userMetadata.display_name && (
									<div className="user-name disabled">{userMetadata.display_name}</div>
								)}
							</li>
							<li className="disabled-menu-item"><a className="disabled"><InfoCircle/> About</a></li>
							<li className="disabled-menu-item"><a className="disabled"><Mail01/> Contact Us</a></li>
							<li className="disabled-menu-item"><a className="disabled"><LogOut04/> Log out</a></li>
						</>
						) : (<>
							<li className="disabled-menu-item"><a className="disabled"><ArrowCircleBrokenUpRight/> Sign up</a></li>
							<li className="disabled-menu-item"><a className="disabled"><LogIn04/> Log in</a></li>
							<hr className="menu-division"/>
							<li className="disabled-menu-item"><a className="disabled"><InfoCircle/> About</a></li>
							<li className="disabled-menu-item"><a className="disabled"><Mail01/> Contact Us</a></li>
							</>
					)}
				</ul>
			</div>
			{notificationVisible && (
                <div className={'notification'}>
                    Link copied to clipboard!
                </div>
            )}
		</div>
	)
}
export default Burger;